import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UiService {
  public showNotification = (id: string, message: string, title: string = 'Gopher Buddy'): void => {
    chrome.notifications.clear(id, () => {});
    chrome.notifications.create(
      id,
      {
        message,
        title,
        type: 'basic',
        iconUrl: 'assets/images/gb_default_icon.png',
      },
      () => {}
    );
  };
}
